var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({
    height: '30px'
  })},[_c('label',{style:({
      //font: 'normal normal normal 16px/19px Lato',
      fontSize: '16px/19px',
      color: '#333333',
      verticalAlign: 'middle'
    })},[_vm._v(_vm._s(_vm.field.title)+" "),(_vm.field.required)?_c('span',[_vm._v("*")]):_vm._e(),(!_vm.field.required)?_c('span',{style:({ color: '#707070' })},[_vm._v("- optional")]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }